'use client'
import React, { FC } from 'react'
import ButtonGradientEpic from '@/components/button-gradient-epic'
import Button from '@/components/button'
import DelistButton from '@/components/inscription-actions/inscription-action-cancel'
import event from '@/utils/event'
import useSatoshiPrice from '@/utils/hooks/useSatoshiPrice'
import { NETWORK } from '@/utils/constants'
import { formatSatsPer } from '@/utils/format-sats'

const InscriptionCardSmall: FC<{
	inscription: any
	collection: any
	ticker: string
	description: string
	children?: React.ReactNode
	onList: (evt: any) => void
	onTransfer: (evt: any) => void
}> = (props) => {
	const { inscription, collection: _collection, ticker, description, onList, onTransfer } = props
	const price = useSatoshiPrice(inscription?.escrow?.satoshi_price)

	const { sats, per } = formatSatsPer(
		inscription?.escrow?.satoshi_price / parseFloat(inscription?.meta?.attributes?.[0]?.value)
	)

	return (
		<div className="bg-background p-4 w-full rounded flex gap-4 flex-col">
			<div className="flex items-center gap-2">
				<div className="flex flex-col">
					<p className="text-xs semibold">{ticker}</p>
					<p className="text-xs text-zinc-500 flex items-center gap-1">{description}</p>
				</div>
				<div className="grow" />
				<div className="flex gap-2">
					{!inscription?.escrow && (
						<>
							<Button
								background="white"
								className="h-[32px] text-foreground rounded-full text-sm font-semibold bg-chrome-muted"
								onClick={onTransfer}
							>
								Transfer
							</Button>
							<ButtonGradientEpic
								className="h-[32px] rounded-full text-sm font-semibold"
								onClick={onList}
							>
								List
							</ButtonGradientEpic>
						</>
					)}
					{!!inscription?.escrow && (
						<>
							<div className="flex justify-right flex-col">
								<p className="text-sm font-bold">
									{price} {NETWORK}
								</p>
								<p className="text-xs font-bold text-muted-foreground">
									{sats} {per}/
									{inscription?.collection?.slug.replace('dot', '.').split('-')[1].toUpperCase()}
								</p>
							</div>
							<DelistButton
								id={inscription.id}
								onComplete={() => {
									event.emit('list-item', {
										type: 'cancel',
										cancelled: true,
										id: inscription.id
									})
								}}
							/>
						</>
					)}
				</div>
			</div>
			{props.children}
		</div>
	)
}

export default InscriptionCardSmall
